export const links = {
	coinMarketCapUrl: "https://coinmarketcap.com/exchanges/btc-alpha/",
	coinGeckoUrl: "https://www.coingecko.com/en/exchanges/btc-alpha",
	card: "https://card.btc-alpha.com",
}
